"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.common.white,
  position: 'sticky',
  bottom: 0,
  display: 'flex',
  flexFlow: 'column',
  padding: theme.spacing(3),
  width: '100%',
  zIndex: 2
}));
const TopDivider = (0, _mui.styled)(_mui.Divider)(({
  theme
}) => ({
  borderTop: `2px solid ${theme.palette.grey[100]}`,
  borderWidth: '2px 0 0',
  marginBottom: theme.spacing(2),
  width: '100%'
}));
const Buttons = ({
  isDisabled,
  isLoading,
  onAddOffer
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    "data-testid": getTestId(_models.TestId.ButtonsWrapper),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TopDivider, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      maxWidth: "500px",
      color: "primary",
      "data-testid": getTestId(_models.TestId.AddOfferButton),
      disabled: isLoading || isDisabled,
      loading: isLoading,
      variant: "contained",
      sx: {
        marginTop: 2
      },
      onClick: onAddOffer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "buyProductAndGetFreeDelivery"
      })
    })]
  });
};
exports.Buttons = Buttons;